<template>
  <div>
    <component v-bind:is="componentType"
               :fieldName="fieldName"
               :loading="loading"
               :options="options"
               :uniqueId="uniqueId"
               :disabled="disabled"
               optionLabel="label"/>
  </div>
</template>

<script>
import DynamicInputText from "./DynamicInputText";
import DynamicDropDown from "./DynamicDropDown";
import DynamicTreeSelect from "./DynamicTreeSelect";
import DynamicCheckbox from "./DynamicCheckbox";
import DynamicListSelect from "./DynamicListSelect";
import DynamicTimeSpan from "./DynamicTimeSpan";
import DynamicNumberInput from "./DynamicNumberInput";
import SearchFieldService from '../services/searchfield.service';
import {mapActions, mapGetters} from 'vuex';

export default {
  name: "DynamicSearchInput",
  components: {
    DynamicInputText,
    DynamicTreeSelect,
    DynamicCheckbox,
    DynamicDropDown,
    DynamicListSelect,
    DynamicNumberInput,
    DynamicTimeSpan
  },
  props: {
    uniqueId: Number,
    fieldName: String,
    fieldType: String,
    fieldOption: String,
    disabled: {
      type: Boolean,
      default: false
    }

  },
  data() {
    return {
      loading: false,
      options: []
    }
  },
  computed: {
    ...mapGetters('search',
        ['getSearchRow']
    ),
    componentType() {
      if (this.fieldType != null) {
        if (this.fieldType === 'LOOKUP') {
          if (this.fieldOption === 'CONTAINS') {
            return 'DynamicListSelect';
          } else {
            return 'DynamicDropDown';
          }
        }
        if (this.fieldType === 'TREE') {
          return 'DynamicTreeSelect';
        }
        if (this.fieldType === 'BOOLEAN') {
          return 'DynamicCheckbox';
        }
        if (this.fieldType === 'TIME_SPAN') {
          return 'DynamicTimeSpan'
        }
        if (this.fieldType === 'NUMBER') {
          return 'DynamicNumberInput';
        }
      }
      return 'DynamicInputText';
    }
  },
  methods: {
    ...mapActions('search', [
      'setData'
    ]),
    load() {
      if (this.fieldName != null) {
        if (this.fieldType === 'LOOKUP') {
          this.loading = true;
          SearchFieldService.loadLookupData(this.fieldName).then(r => {
            this.options = r.data;
            this.loading = false;
          })
        }
      }
    },
  },
  watch: {
    fieldName: function () {
      this.load();
    }
  },
}
</script>

<style scoped>

</style>